import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { setUser } from "../redux/features/userSlice";

export default function ProtectedRoute({ children }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const { user } = useSelector((state) => state.user);

  const token = localStorage.getItem("token");

  useEffect(() => {
    if (!token) {
      dispatch(setUser(null));
      return;
    }

    if (user) return;

    let cancelled = false;

    (async () => {
      try {
        const res = await axios.post(
          "/api/user/getUserData",
          {},
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (!cancelled && res.data?.success) {
          dispatch(setUser(res.data.data.user));
        } else if (!cancelled) {
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          dispatch(setUser(null));
        }
      } catch (err) {
        if (!cancelled) {
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          dispatch(setUser(null));
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [token, user, dispatch]);

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return children;
}
